import _IntroIcon from '../images/icon-intro.svg';
import _GearIcon from '../images/icon-gear.svg';
import _SyncIcon from '../images/icon-sync.svg';
import _LinkIcon from '../images/icon-link-2.svg';
import _QuestionIcon from '../images/icon-question.svg';
import _InfoIcon from '../images/icon-info.svg';
import _DownloadIcon from '../images/icon-download.svg';
import _NoIcon from '../images/NoIcon.png';
import _CancelIcon from '../images/cancel.svg';
import _VideoPlayIcon from '../images/videoplay.svg';
import { IconVariation } from '@testout/labsim-ui-atomics';
// resource icons
export const BlankIcon = cdnImage('resource/blank.png');
export const VideoIcon = cdnImage('resource/video.png');
export const SimulationIcon = cdnImage('resource/sim.png');
export const TextIcon = cdnImage('resource/text.png');
export const DemoIcon = cdnImage('resource/demo.png');
export const ExamIcon = cdnImage('resource/exam.png');
export const GenericProductIcon = cdnImage('generic-course.png');
// other icons
export const GearIcon = _GearIcon;
export const SyncIcon = _SyncIcon;
export const LinkIcon = _LinkIcon;
export const ModuleIcon = _IntroIcon;
export const DownloadIcon = _DownloadIcon;
export const InfoIcon = _InfoIcon;
export const QuestionIcon = _QuestionIcon;
export const CancelIcon = _CancelIcon;
export const VideoPlayIcon = _VideoPlayIcon;
// product icons
export const NoProductIcon = _NoIcon;
export function cdnImage(image) {
    return `https://cdn.testout.com/labsimsaas/images_v2/${image}`;
}
export var Guid;
(function (Guid) {
    Guid["EMPTY"] = "00000000-0000-0000-0000-000000000000";
})(Guid || (Guid = {}));
export const LatestResourceType = 'default';
export var ResourceType;
(function (ResourceType) {
    ResourceType["DEMO"] = "D";
    ResourceType["EXAM"] = "E";
    ResourceType["TEXT_LESSON"] = "T";
    ResourceType["SIMULATION"] = "S";
    ResourceType["VIDEO"] = "V";
    ResourceType["NONE"] = "N";
    ResourceType["MODULE"] = "X";
})(ResourceType || (ResourceType = {}));
export const ResourceTypes = {
    [ResourceType.MODULE]: 'Section Headings',
    [ResourceType.VIDEO]: 'Video Lessons',
    [ResourceType.DEMO]: 'Demonstrations',
    [ResourceType.TEXT_LESSON]: 'Text Lessons',
    [ResourceType.SIMULATION]: 'Lab Simulations',
    [ResourceType.EXAM]: 'Practice Questions',
};
export default class ResourceHelper {
    static getResourceIcon(sectionType, defaultIcon) {
        switch (sectionType) {
            case ResourceType.VIDEO:
                return IconVariation.Video;
            case ResourceType.SIMULATION:
                return IconVariation.Lab;
            case ResourceType.TEXT_LESSON:
                return IconVariation.Text;
            case ResourceType.DEMO:
                return IconVariation.Demo;
            case ResourceType.EXAM:
                return IconVariation.Exam;
            case ResourceType.MODULE:
                return IconVariation.Start;
        }
        if (defaultIcon)
            return defaultIcon;
        return IconVariation.Circle;
    }
    static sortSectionNumbers(a, b) {
        const x = a.sectionNumber.split('.');
        const y = b.sectionNumber.split('.');
        for (let i = 0; i < 3; i++) {
            // tslint:disable-next-line:radix
            const xNum = parseInt(x[i]);
            // tslint:disable-next-line:radix
            const yNum = parseInt(y[i]);
            const xIsNaN = isNaN(xNum);
            const yIsNaN = isNaN(yNum);
            if (!xIsNaN && !yIsNaN) {
                // both are numbers, do parsed number compares
                if (xNum > yNum) {
                    return 1;
                }
                if (xNum < yNum) {
                    return -1;
                }
            }
            else if (xIsNaN && yIsNaN) {
                // both are chars normal compares work with strings
                if (x[i] > y[i]) {
                    return 1;
                }
                if (x[i] < y[i]) {
                    return -1;
                }
            }
            else if (xIsNaN && !yIsNaN && i === 0) {
                // we sort non-numbers sections (A.*.*) after numbers
                return 1;
            }
            else if (xIsNaN && !yIsNaN && i > 0) {
                // we sort non-numbers sections (*.1 vs *.1.*) before numbers when not first letter
                return -1;
            }
            else if (!xIsNaN && yIsNaN && i === 0) {
                return -1;
            }
            else if (!xIsNaN && yIsNaN && i > 0) {
                return 1;
            }
        }
        return 0;
    }
}
//# sourceMappingURL=ResourceHelper.js.map